import moment from 'moment';

const today = moment()
  .add(1, 'days')
  .format('YYYY-MM-DD');

export default {
  chip: {
    label: 'Carteira de PDV TIM',
    type: 'PDV',
    inputs: [
      {
        label: 'Custcode',
        placeholder: 'Informe o custcode',
        model: 'custCode',
        class: 'lg:col-4',
        is: 'SmartInput'
      }
    ]
  },
  usuario: {
    label: 'Usuários TIM Smart',
    type: 'USER_PERMISSIONS',
    inputs: [
      {
        label: 'Matrícula do Usuário',
        placeholder: 'Informe o número da matrícula',
        model: 'registration',
        class: 'lg:col-4',
        mask: '#'.repeat(7),
        is: 'SmartInput'
      }
    ]
  },
  carteira: {
    label: 'Carteira PDV (On-Demand)',
    type: 'PDV_MY_LOCATION',
    inputs: [
      {
        label: 'Custcode',
        placeholder: 'Informe o custcode',
        model: 'custCode',
        class: 'lg:col-4',
        is: 'SmartInput'
      }
    ]
  },
  jornada: {
    label: 'Jornada com Km',
    type: 'JOURNEY',
    inputs: [
      {
        label: 'Custcode',
        placeholder: 'Informe o custcode',
        model: 'custCode',
        class: 'lg:col-4',
        is: 'SmartInput'
      },
      {
        label: 'Data inicial',
        placeholder: '15/02/2019',
        model: 'from',
        class: 'lg:col-3',
        type: 'date-picker',
        is: 'SmartInput',
        notAfter: today
      },
      {
        label: 'Dia final',
        placeholder: '15/02/2019',
        model: 'to',
        class: 'lg:col-3',
        type: 'date-picker',
        is: 'SmartInput',
        notAfter: today
      }
    ]
  },
  usabilidade: {
    label: 'Usabilidade',
    type: 'USABILITY'
  }
};
